import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BaseService } from '../services/misc/base.service';
import { ConfigService } from '../configuration/services/config.service';
import { LoggingService } from '../logging/logging.service';
import { UtilsMisc } from '../utils/utils.misc';
import { IPITEventService } from './pit.event.service.interface';

export interface IEventSubjectWrapper {

  eventName: string;
  subject$: Subject<any>;

}

export interface IEventMethodWrapper {

  methodName: string;
  method: (value?: any) => void;

}

@Injectable({
  providedIn: 'root'
})
export class PITEventService extends BaseService implements IPITEventService {

  constructor(configService: ConfigService, loggingService: LoggingService) {
    super(configService, loggingService);
  }

  public releaseSubscriptionForEvent(eventName: string, subscription: Subscription): void {
    this.doReleaseSubscriptionForEvent(eventName, subscription);
  }

  public subscribeForEvent(eventName: string, method: (value: any) => void): Subscription {
    return this.doSubscribeForEvent(eventName, method);
  }

  public registerMethod(methodName: string, method: (value?: any) => void) {
    let eventMethodWrapper: IEventMethodWrapper = this.getWrapperForMethodName(methodName);
    if (eventMethodWrapper === null) {
      eventMethodWrapper = {
        methodName: methodName,
        method: method
      };
      this.eventMethodWrappers.push(eventMethodWrapper);
    }
  }

  public useMethod(methodName: string, value: any = null): void {
    let eventMethodWrapper: IEventMethodWrapper = this.getWrapperForMethodName(methodName);
    if (eventMethodWrapper !== null) {
      eventMethodWrapper.method(value);
    }
  }

  public sendEvent(eventName: string, event: any = null): void {
    this.doSendEvent(eventName, event);
  }

  protected readonly eventSubjectWrappers: IEventSubjectWrapper[] = [];

  protected readonly eventMethodWrappers: IEventMethodWrapper[] = [];

  protected doReleaseSubscriptionForEvent(eventName: string, subscription: Subscription): void {
    subscription.unsubscribe();
  }

  protected doSubscribeForEvent(eventName: string, method: (value: any) => void): Subscription {
    let eventSubjectWrapper: IEventSubjectWrapper = this.getWrapperForEventName(eventName);
    if (eventSubjectWrapper === null) {
      eventSubjectWrapper = {
        eventName: eventName,
        subject$: new Subject<any>()
      };
      this.eventSubjectWrappers.push(eventSubjectWrapper);
    }
    return eventSubjectWrapper.subject$.subscribe((item) => {
      method(item)
    });
  }

  protected doSendEvent(eventName: string, event: any): void {
    let eventSubjectWrapper: IEventSubjectWrapper = this.getWrapperForEventName(eventName);

    if (eventSubjectWrapper !== null) {
      eventSubjectWrapper.subject$.next(event);
    }
  }

  protected getWrapperForEventName(eventName: string): IEventSubjectWrapper {
    let result: IEventSubjectWrapper = this.eventSubjectWrappers.find(x => (x.eventName === eventName));
    if (UtilsMisc.isNullOrUndefined(result) === true) {
      result = null;
    }
    return result;
  }

  protected getWrapperForMethodName(methodName: string): IEventMethodWrapper {
    let result: IEventMethodWrapper = this.eventMethodWrappers.find(x => (x.methodName === methodName));
    if (UtilsMisc.isNullOrUndefined(result) === true) {
      result = null;
    }

    return result;
  }

}
